import { useCallback, useMemo } from 'react';
import { useFeatureSwitchEnabled } from './useFeatureSwitchEnabled';
import { FEATURES_LIST } from 'src/context/featureSwitch';
import { useCarDetailsDuck } from './useCarDetailsDuck';
import routes from 'src/constants/routes';
import useCustomRouter from './useCustomRouter';
import { useCarStockJourneyCheck } from './useCarStockJourneyCheck';
import isEmpty from 'lodash/isEmpty';

export const useRedirection = () => {
    const isDealerChoiceEnabled = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_IS_DEALER_CHOICE_ENABLED);
    const { carDetails, currentDeal } = useCarDetailsDuck();
    const router = useCustomRouter();
    const { isStockJourney } = useCarStockJourneyCheck();

    const isDealerSelected = useMemo(() => {
        return carDetails?.dealers?.[0] || !!currentDeal?.dealerId;
    }, [carDetails?.dealers, currentDeal]);

    const canRedirectToBasket = useMemo(() => {
        return isDealerChoiceEnabled ? (isDealerSelected && !isStockJourney) || isStockJourney : true;
    }, [isDealerSelected, isStockJourney, isDealerChoiceEnabled]);

    const redirectToBasket = useCallback(() => {
        if (canRedirectToBasket && router.pathname !== routes.BASKET) {
            router.push(routes.BASKET);
        } else if (!canRedirectToBasket && router.pathname !== routes.DEALER) {
            if (!isEmpty(carDetails)) {
                router.push(routes.DEALER);
            } else {
                // show empty basket scenario
                router.push(routes.BASKET);
            }
        }
    }, [isDealerSelected, isStockJourney, canRedirectToBasket, carDetails]);

    return {
        redirectToBasket,
        canRedirectToBasket,
    };
};
